import React from 'react';

import { flagStyles } from '../settings';

const SvgMM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3456px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMM;
